import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appExpandedComponent]',
  standalone: true
})
export class ExpandedComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
